<template>
  <div id="page-beneficiary-form">
    <vs-row>
      <vs-col :class="readonly ? 'readonly-form' : ''">
        <card-page :card-title="cardTitle">
          <vue-element-loading :active="busy"></vue-element-loading>
          <vue-form-generator
              ref="form"
              :model="model"
              :options="formOptions"
              :schema="schema"
              :class="readonly ? 'readonly-form' : ''"
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import FormModelMixin from '@/components/mixins/FormModelMixin';
import FormFieldValidationMixin from "@/components/mixins/FormFieldValidationMixin";
import CardPage from '../../../components/Views/CardPage';

export default {
  name: 'BeneficiaryForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    cardTitle: {
      type: String,
      required: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    CardPage,
  },
  mixins: [FormModelMixin, FormFieldValidationMixin],
  data() {
    return {
      model: {
        BeneficiaryFirstName: null,
        BeneficiaryLastName: null,
        BeneficiaryEmailAddress: null,
        BeneficiaryBankAccountName: null,
        iban: null,
      },
      schema: {
        groups: [
          {
            styleClasses: 'w-full',
            legend: 'General',
            fields: [
              {
                disabled: () => this.readonly,
                type: 'input',
                inputType: 'text',
                styleClasses: 'vx-col w-1/3',
                label: 'First Name',
                model: 'BeneficiaryFirstName',
                validator: 'string',
                required: () => !this.readonly,
              },
              {
                disabled: () => this.readonly,
                type: 'input',
                inputType: 'text',
                styleClasses: 'vx-col w-1/3',
                label: 'Last Name',
                model: 'BeneficiaryLastName',
                validator: 'string',
                required: () => !this.readonly,
              },
              {
                disabled: () => this.readonly,
                type: 'input',
                inputType: 'email',
                styleClasses: 'vx-col w-1/3',
                label: 'Email Address',
                model: 'BeneficiaryEmailAddress',
                validator: ['string', 'email'],
                required: () => !this.readonly,
              },
              {
                disabled: () => this.readonly,
                type: 'input',
                inputType: 'text',
                styleClasses: 'vx-col w-1/3',
                label: 'Bank Account Name',
                model: 'BeneficiaryBankAccountName',
                validator: 'string',
                required: () => !this.readonly,
              },
              {
                disabled: () => this.readonly,
                type: 'input',
                inputType: 'text',
                styleClasses: 'vx-col w-1/3',
                label: 'IBAN',
                model: 'iban',
                validator: ['string', 'iban'],
                required: () => !this.readonly,
              },
            ]
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
    };
  },
};
</script>

